import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ElectronicSignatureHome() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLearnMore = () => {
    navigate("/e-signature-laws");
  };

  return (
    <section className="guest-container my-5">
      <div className="lb-inner">

        <p className="lb-label">{t("electronicSignature.label")}</p>

        <h1 className="lb-title">{t("electronicSignature.title")}</h1>

        <p className="lb-subtitle">{t("electronicSignature.subtitle")}</p>

        <button className="lb-cta-btn" onClick={handleLearnMore}>
          <span>{t("electronicSignature.cta")}</span>
          <span className="lb-cta-arrow">→</span>
        </button>

        <p className="lb-fine-print">{t("electronicSignature.finePrint")}</p>
      </div>
    </section>
  );
}
